import {
  PROFILE_CLASS_NAME,
  PROFILES_PATH,
  updateCurrentProfileAction
} from '@gymaholic/packages'
import createReduxAction from 'modules/redux/actions/create'
import getProfileDataFromLocalStorageProfileUtil from 'modules/profile/utils/get-profile-data-from-local-storage/index.js'
import { logUtil } from 'packages/src'
import existsProfileSelect from 'modules/profile/redux/selectors/exists/index.js'

export function createProfileAction () {
  return (dispatch, getState) => {
    const profileExists = existsProfileSelect(getState())

    if (profileExists) {
      logUtil('createProfileAction').debug('[noop] profile already exists')
      return
    }

    const instance = dispatch(
      createReduxAction({
        type: 'CREATE_PROFILE',
        payload: {
          domainListPath: PROFILES_PATH.ALL,
          data: {
            className: PROFILE_CLASS_NAME,
            changed: getProfileDataFromLocalStorageProfileUtil()
          }
        }
      })
    )

    dispatch(updateCurrentProfileAction(instance))
    return instance
  }
}
